import React from 'react'

import { momentDateHandler } from '../../../date/moment-date-handler'

const { newDate, formatDate } = momentDateHandler

export const renderDateColumn = (date: Date) => <>{formatDate({ date: newDate(date) })}</>

export const renderDateTimeColumn = (date: Date) => (
  <>{formatDate({ date: newDate(date), format: 'DD/MM/YYYY - HH:mm:ss' })}</>
)

export const renderCustomDateFormatColumn = ({ date, format }: { date: Date; format?: string }) => (
  <>{formatDate({ date: newDate(date), format })}</>
)
